export const getYoutubeEmbedUrl = (url) => {
  try {
    const urlObj = new URL(url);
    let videoId = null;

    if (urlObj.hostname === "youtu.be") {
      videoId = urlObj.pathname.slice(1);
    } else {
      videoId = urlObj.searchParams.get("v");
    }
    if (!videoId) throw new Error("Video ID not found");

    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  } catch (e) {
    console.error("Invalid YouTube URL:", url);
    return null;
  }
};

export function getYoutubeVideoId(url) {
  const match = url?.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/
  );
  return match ? match[1] : null;
}

export function getYoutubeThumbnailUrl(input, quality = "maxresdefault") {
  if (!input) return null;

  const isUrl = input.includes("youtube.com") || input.includes("youtu.be");

  const videoId = isUrl ? getYoutubeVideoId(input) : input;
  return videoId
    ? `https://img.youtube.com/vi/${videoId}/${quality}.jpg`
    : null;

  // uses with full url
  //   const thumbnailUrl = getYoutubeThumbnailUrl(student.video_link);
  //  or pass ID directly
  // const thumbnailFromId = getYoutubeThumbnailUrl("abc123xyz", "maxresdefault");
}
